
import { myCategoryActions } from ".";
import {
  getAllCategoryService,
} from "./services";


export const getAllCategoriesAction = (query) => {
  return async (dispatch) => {
    try {
      dispatch(myCategoryActions.setIsFetching(true));
      const res = await getAllCategoryService(query);
      if (res?.status === 200) {
        dispatch(myCategoryActions.setAll(res));
        dispatch(myCategoryActions.setIsFetching(false));
      }
      dispatch(myCategoryActions.setIsFetching(false));
    } catch (err) {
      console.error(err);
    }
  };
};